export const AVAILABLE_LOCALES = ['en', 'ar']

export const A_B_KEY = 'qic-qatar-travel_flow_ab_state'
export const INSURENCE_VALUES_SINGLE_PLAN_TEST_KEY = 'QATTRINSVALUES'
export const INSURENCE_VALUES_MULTI_PLAN_TEST_KEY = 'QATTRINSVALUESMULTI'
export const AIRALO_TEST_KEY = 'TRAVELQATAIRALO'
export const AIRALO_TEST_VALUES = ['TRAVELQATAIRALO-B1', 'TRAVELQATAIRALO-B2']
